var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_200",
    d: "M0.8349 7.62067H17.1735",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_201",
    d: "M13.0719 11.2006H13.0804",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_202",
    d: "M9.00422 11.2006H9.01271",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_203",
    d: "M4.92804 11.2006H4.93654",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_204",
    d: "M13.0719 14.7632H13.0804",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_205",
    d: "M9.00422 14.7632H9.01271",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_206",
    d: "M4.92804 14.7632H4.93654",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_207",
    d: "M12.7068 0.833374V3.84992",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_208",
    d: "M5.30174 0.833374V3.84992",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8851 2.28101H5.12338C2.43142 2.28101 0.75 3.78061 0.75 6.53711V14.8326C0.75 17.6325 2.43142 19.1667 5.12338 19.1667H12.8766C15.577 19.1667 17.25 17.6585 17.25 14.902V6.53711C17.2585 3.78061 15.5855 2.28101 12.8851 2.28101Z",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionCalendar);
export default __webpack_public_path__ + "static/media/sessionCalendar.56960ebcedfff937138d2058bc73d76c.svg";
export { ForwardRef as ReactComponent };